<template>
  <div class="ds-control mobile dsf_teas_student_report">
    <div class="report-content">
      <div class="stu-infor">
        <div class="title">学员信息</div>
        <div class="stu-items">
          <div class="stu-item topLine">
            <div class="stu-item-left">学员姓名</div>
            <div class="stu-item-right">{{ attendInfor.xm }}</div>
          </div>
          <div class="stu-item">
            <div class="stu-item-left">手机号码</div>
            <div class="stu-item-right">{{ attendInfor.sjhm }}</div>
          </div>
          <div class="stu-item">
            <div class="stu-item-left">身份证号</div>
            <div class="stu-item-right">{{ attendInfor.sfzh }}</div>
          </div>
          <div class="stu-item noBtmPadding">
            <div class="stu-item-left">组别</div>
            <div class="stu-item-right">
              {{ attendInfor.group_name ? attendInfor.group_name : "暂无分组" }}
            </div>
          </div>
        </div>
      </div>
      <div class="class-infor">
        <div class="title">班级信息</div>
        <div class="class-items">
          <div class="class-item topLine">
            <div class="class-item-left">班级名称</div>
            <div class="class-item-right">
              {{ attendInfor.class_name }}
            </div>
          </div>
          <div class="class-item">
            <div class="class-item-left">培训时间</div>
            <div class="class-item-right">
              {{ attendInfor.pxsj }}
            </div>
          </div>
          <div class="class-item">
            <div class="class-item-left">班主任</div>
            <div class="class-item-right">{{ attendInfor.bzr_text }}</div>
          </div>
          <div class="class-item noBtmPadding">
            <div class="class-item-left">上课地点</div>
            <div class="class-item-right">
              {{ attendInfor.skdd_text ? attendInfor.skdd_text : "暂无" }}
            </div>
          </div>
        </div>
      </div>
      <div class="scan-infor" v-if="type == 2">
        <div class="reportSucess" v-if="attendInfor.status_value == '1'">
          <img
            class="img"
            :src="require('_teas/assets/themes/img/reportResouse/bdcg.png')"
            alt=""
            srcset=""
          />
          <div class="success">
            <div class="title">报到成功，欢迎您来参加培训！</div>
            <div class="time">{{ attendInfor.register_date }}</div>
          </div>
        </div>
        <div class="noReport" v-else>
          <img
            class="img"
            :src="require('_teas/assets/themes/img/reportResouse/wbd2.png')"
            alt=""
            srcset=""
          />
          <div class="title">未报到</div>
        </div>
      </div>
      <div class="location-infor" v-else>
        <div class="reportSucess" v-if="attendInfor.status_value == '1'">
          <img
            class="img"
            :src="require('_teas/assets/themes/img/reportResouse/dwcg.png')"
            alt=""
            srcset=""
          />
          <div class="success">
            <div class="tip">定位报到成功</div>
            <div class="title">{{ attendInfor.registerLocation }}</div>
            <div class="time">{{ attendInfor.register_date }}</div>
          </div>
        </div>
        <div class="noReport" v-else>
          <img
            class="img"
            :src="require('_teas/assets/themes/img/reportResouse/wbd.png')"
            alt=""
            srcset=""
          />
          <div class="title">
            <div>未报到</div>
            <div class="address">
              {{ locationInfor.address ? locationInfor.address : "" }}
            </div>
          </div>
          <div class="locationbtn" @click="locationAddr">一键导航</div>
        </div>
      </div>
    </div>
    <van-button
      v-if="attendInfor.status_value == '0'"
      :class="attendInfor.status_value == 1 ? 'hasReportBtn' : ''"
      type="primary"
      class="btn-scan"
      block
      @click="clickReport"
    >
      报到
    </van-button>
  </div>
</template>
<script>
const testData = {
  bzr_text: "校领导",
  group_name: "第一小组",
  class_name: "第50期中青年干部培训班二班",
  pxsj: "2021-09-01至2021-10-30",
  sfzh: "511028199502010005",
  sjhm: "18700000007",
  skdd_text: null,
  status_value: "1",
  xm: "学员7",
  register_date: "",
  registerLocation: "",
};
export default dsf.component({
  name: "DsfMobileTeasReportDuty",
  mixins: [$mixins.control],
  ctrlCaption: "学员报到",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "teas/checkManagement/getRegisterInfo",
    },
  },
  data() {
    return {
      attendInfor: {}, // 扫码
      type: 1, // 默认定位  2扫码 1定位
      setClassInfor: {
        setting_classes_radius: "",
        setting_classes_latitude: "",
        setting_classes_longitude: "",
      },
      locationInfor: {
        'address': '',
        'lng': '',
        'lat': ''
      },
    };
  },
  created() {
    this.type = this.queryString.type;
    if (this.type == 1) {
      this.setClassInfor.setting_classes_latitude = this.queryString.latitude;
      this.setClassInfor.setting_classes_longitude = this.queryString.longitude;
      this.setClassInfor.setting_classes_radius = this.queryString.radius;
    }
    if (this.isDesign) {
      this.attendInfor = testData;
    } else {
      //获取信息
      this.getAddanceInfor(0);
    }
    if (dsf.client.weixin() && window.$wx) {
      window.$wx.init();
    }
  },
  activated: function () {
    if (this.isDesign) {
      this.attendInfor = testData;
    } else {
      //获取信息
      this.getAddanceInfor(1);
    }
  },
  methods: {
    // 判断两个点之间的距离
    getGreatCircleDistance(lat1, lng1, lat2, lng2) {
      var EARTH_RADIUS = 6378137.0;
      var PI = Math.PI;

      function getRad(d) {
        return (d * PI) / 180.0;
      }
      var radLat1 = getRad(lat1);
      var radLat2 = getRad(lat2);

      var a = radLat1 - radLat2;
      var b = getRad(lng1) - getRad(lng2);

      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000.0;

      return s;
    },
    locationAddr() {
      var loading = dsf.layer.loading("定位中");
      dsf.driver.location
        .getBD()
        .then((result) => {
          dsf.layer.closeLoading(loading);
          var place = result.address;
          var lat = result.lat;
          var lng = result.lng;
          if (!lat || !lng) {
            dsf.layer.alert({
              title: "定位失败",
              message: "请打开GPS定位",
            });
            return;
          }
          this.locationInfor = result;
          if (dsf.client.wechat()) {
            this.locationInverseCoding();
          } 
        })
        .catch((res) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.alert(JSON.stringify(res));
        });
        // 这种处理安卓那边无法返回定位强行关闭loading
        setTimeout(() => {
          dsf.layer.closeLoading(loading);
        }, 6000)
    },
    // 微信获取地点名称
    locationInverseCoding: function() {
      this.$http
      .get("teas/attendance/locationInverseCoding", {
        longitude: this.locationInfor.lng,
        latitude: this.locationInfor.lat,
      })
      .done((res) => {
        if (res.success && res.state == 20000) {
           this.locationInfor.address = res.data ? res.data : '';
        } else {
          dsf.layer.message(res.message, false);
        }
      })
      .error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
      .always(() => {});
    },
    //
    clickReport() {
      if (this.attendInfor.status_value == 1) {
        // 已经报到
        return;
      }
      if (this.$listeners["report"]) {
        this.$dispatch("report");
        return;
      }
      if (this.type == "1") {
        // 定位
        if (!this.locationInfor.lat || !this.locationInfor.lng) {
          dsf.layer.alert({
            message: "请先定位",
          });
          return;
        }
        var distance = this.getGreatCircleDistance(
          this.locationInfor.lat,
          this.locationInfor.lng,
          this.setClassInfor.setting_classes_latitude,
          this.setClassInfor.setting_classes_longitude
        );
        if (
          parseInt(distance) >
          parseInt(this.setClassInfor.setting_classes_radius)
        ) {
          dsf.layer.alert({
            title: "温馨提示",
            message:
              "请到" +
              this.setClassInfor.setting_classes_radius +
              "米范围内重新定位报到",
          });
          return;
        }
        var address = this.locationInfor.address ? this.locationInfor.address : ""
        var url = "/mobile/teas/classes/student/studentmanager/mobile-edit_stuinfo_unphoto?id="+this.dsf.getCookie("stuId")+"&isFromReport=1&registerLocation="+address;
        this.$router.push(url);
        
      } else {
        // 扫码
        dsf.driver.camera
          .scan()
          .then((result) => {
            if (!result) return;
            if (result == "error") return;
            var class_id = this.dsf.getCookie("class_id");
            if (result == class_id) {
              this.$router.push({
                path:
                  "/mobile/teas/classes/student/studentmanager/mobile-edit_stuinfo_unphoto?id=" +
                  this.dsf.getCookie("stuId") +
                  "&isFromReport=1&registerLocation=",
              });
            } else {
              dsf.layer.message("报到二维码错误", false);
            }
          })
          .catch((msg) => {
            dsf.layer.alert(JSON.stringify(msg));
          });
      }
    },
    // 获取信息
    getAddanceInfor(num) {
      var loading;
      if (num == 0) {
        loading = dsf.layer.loading();
      }
      this.$http
        .get("teas/checkManagement/getRegisterInfo", {
          stuId: dsf.getCookie("stuId"),
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.attendInfor = res.data;
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          if (num == 0) {
            dsf.layer.closeLoading(loading);
          }
        });
    },
  },
});
</script>